export class MainHeaderlabel_EN {

    mainHeader: {
        title: string;
        welcomeText: string;
    }

    menu: {
        home: string;
        about: string;
        howItWorks: string;
        logout: string;
        faq: string;
    }

    about: {
        title: string;
        closeBtn: string;
    }

    constructor() {

        this.mainHeader = {
            title: "Pre - Approval Management System",
            welcomeText: "Welcome"
        }

        this.menu = {
            home: "Home",
            about: "About",
            howItWorks: "How it works",
            logout: "Logout",
            faq: "FAQ"
        }

        this.about = {
            title: "About",
            closeBtn: "Close"
        }
    }
}